import Client from 'shopify-buy';

const accessToken = '3950c459025c36e73a907f5d7b1bd78b';
const domain = 'bw-restaurants-oy';
const appId = '6674907163';

export const shopClient = Client.buildClient({
  accessToken: accessToken,
  domain: domain+'.myshopify.com',
  appId: appId
});

export const getProductsInCollection = (collection) =>
  shopClient.fetchQueryProducts({ collection_id: collection })
  .then(response => response)
  .catch(function () {
    console.log('Request failed');
  });


// WEBPACK FOOTER //
// ./src/api/shopifyAPI.js